import React from 'react';
import CoverImageFour from './CoverImageFour';

import Footer from './Footer';
import Facility from './Facility';



const About = () => {
    return (
        <div>
            <CoverImageFour />
            <Facility />
            <Footer />



        </div>
    );
};

export default About;